import React from "react";
import vid from "../../../videos/Icy_road_SR_1.MOV"

const Video = () => {
    // playsInline + muted: iOS plays the video inline; without playsInline an autoplay
    // video takes over the screen in a fullscreen player.
    return (
        <video autoPlay muted loop playsInline width={"100%"}>
            <source src={vid} type="video/mp4" />
        </video>
    );
}

export default Video